<template>
  <div>
    <v-app style="display: flex">
      <v-navigation-drawer permanent :expand-on-hover="!isMobile" rail app>
        <v-list dense>
          <v-list-item v-for="item in navbarItems" :key="item.tab" :title="item.title" @click="showComponent(item.tab)"
            :class="{ highlighted: true }">
            <template v-slot:prepend>
              <v-icon style="opacity: 1.2;" :color="currentComponent === item.tab ? 'primary' : 'secondary'">
                {{ item.icon }}
              </v-icon>
            </template>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>

      <!-- Main Area to Load Selected Components -->
      <v-main>
        <div v-if="currentComponent === 'ClientPhonesList'">
          <ClientPhonesList />
        </div>
        <div v-else-if="currentComponent === 'ClientEndpoints'">
          <ClientEndpoints />
        </div>
        <div v-else-if="currentComponent === 'SocialMedia'">
          <SocialMedia />
        </div>
        <div v-else-if="currentComponent === 'ODIntegration'">
          <ODIntegration />
        </div>
        <div v-else-if="currentComponent === 'Tags'">
          <FrontDeskSettings  :isTag="true"/>
        </div>
        <div v-else-if="currentComponent === 'ContactTypes'">
          <FrontDeskSettings  :isType="true"/>
        </div>
        <div v-else-if="currentComponent === 'MessageTemplates'">
          <FrontDeskSettings  :isMessageTemplate="true"/>
        </div>
        <div v-else-if="currentComponent === 'GmailIntegration'">
          <GmailIntegration />
        </div>
        <div v-else-if="currentComponent === 'WebChatWidget'">
          <WebChatWidget />
        </div>
        <div v-else-if="currentComponent === 'AllJobsList'">
          <AllJobsList />
        </div>
      </v-main>
    </v-app>
  </div>
</template>

<script>
import ClientEndpoints from "./ClientEndpoints.vue";
import ClientPhonesList from "./ClientPhonesList.vue";
import SocialMedia from "../SocialMedia.vue";
import ODIntegration from "./ODIntegration.vue";
import FrontDeskSettings from "./FrontDeskSettings.vue"
import GmailIntegration from "./GmailIntegration.vue";
import WebChatWidget from "./WebChatWidget.vue";
import AllJobsList from "./AllJobsList.vue";
import { mapGetters } from "vuex";

export default {
  name: "Settings",
  data() {
    return {
      currentComponent: 'ClientEndpoints', // temp default component
    };
  },
  components: {
    ClientEndpoints,
    ClientPhonesList,
    SocialMedia,
    ODIntegration,
    FrontDeskSettings,
    GmailIntegration,
    WebChatWidget,
    AllJobsList
  },
  computed: {
    navbarItems() {
      return this.getItems();
    },
    ...mapGetters("window", ["isMobile"]),
  },
  methods: {
    showComponent(component) {
      this.currentComponent = component;
    },
    getItems() {
      return[
        {
          tab: "ClientPhonesList",
          icon: "mdi-phone-settings",
          title: " Client Phones",
        },
        {
          tab: "ClientEndpoints",
          icon: "mdi-face-agent",
          title: " User Endpoints",
        },
        {
          tab: "SocialMedia",
          icon: "mdi-facebook",
          title: " Social Media",
        },
        {
          tab: "ODIntegration",
          icon: "mdi-link-variant",
          title: " OD Integration"
        },
        {
          tab: "GmailIntegration",
          icon: "mdi-email",
          title: " Gmail Integration",
        },
        {
          tab: "WebChatWidget",
          icon: "mdi-chat-processing-outline",
          title: " Web Chat Widget",
        },
        {
          tab: "Tags",
          icon: "mdi-tag-multiple",
          title: " Tags"
        },
        {
          tab: "ContactTypes",
          icon: "mdi-account-outline",
          title: " Contact Types"
        },
        {
          tab: "MessageTemplates",
          icon: "mdi-message-flash-outline",
          title: " Message Templates"
        },
        {
          tab: "AllJobsList",
          icon: "mdi-auto-mode",
          title: " Jobs List"
        }
      ];
    },
  },
};
</script>